import axios from 'axios';
import { API_HOST } from '../constants/constants';
export const postAutoFAQScan = async (token, userID, url) => {
  const apiURL = API_HOST + '/organization_faqs/scan';
  try {
    const { data } = await axios.post(apiURL,{
      url:url
    },{
      headers: {
      'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-gg-user-id': userID
    }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
